<app-page-wrapper className="intro" contentClass="introContent">

    <div class="jumbo-logo">
      <img draggable="false" [src]="logo" alt="logo">
    </div>
    <section class="form-content">
        <div class="page-caption">{{pageCaption}}</div>
        <ng-content></ng-content>
    </section>

</app-page-wrapper>
